<template>
  <div  style="height:100%">
<img src="../../assets/corneal/接收与登记机构/登记机构.png" style="width:100%;height:100%" alt="">
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {};
  },
  methods: {
    toZxgxb() {
      this.$router.push({
        path: "zxgxb"
      });
    },
    toJxxz() {
      this.$router.push({
        path: "jxxz"
      });
    },
    toCjd() {
      this.$router.push({
        path: "cjd"
      });
    },
    toJxlc() {
      this.$router.push({
        path: "jxlc"
      });
    },
    toSignUp() {
      this.$router.push({
        path: "/HSC/apply"
      });
    }
  },
  components: {},
  mounted() {}
};
</script>


<style lang="less" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  background-image: url("../../assets/corneal/接收与登记机构/接受与登记机构.png");
  background-size: cover;
}

.grid {
  margin-top: 38px;
  display: flex;
  .item {
    width: 143px;
    height: 143px;
  }
  .left {
    display: flex;
    flex-direction: column;
  }
  .right {
    display: flex;
    flex-direction: column;
  }
}
</style>